var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"},{name:"click-esc",rawName:"v-click-esc",value:(_vm.close),expression:"close"}],staticClass:"dropdown-list",class:{
         'dropdown-list_opened': _vm.opened,
         'dropdown-list_disabled': _vm.disabled,
     }},[_c('div',{staticClass:"dropdown-list__label-container",on:{"click":_vm.toggle}},[_vm._t("label")],2),_vm._v(" "),(_vm.opened && !_vm.disabled)?_c('div',{staticClass:"dropdown-list__list-content"},[_vm._t("list")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }